import BaseRecipeTeaser from './BaseRecipeTeaser';
import styles from './BaseRecipeTeaser.module.less';

const BaseRecipeTeaserSkeleton = () => {
    return (
        <BaseRecipeTeaser.Wrapper
            name="loading"
            imageUrl="/Assets/Images/missing-image-product.png"
            clickableImage={false}
        >
            <BaseRecipeTeaser.Content>
                <BaseRecipeTeaser.Info>
                    <div className={styles.SkeletonText} style={{ width: '70%' }} />
                    <div className={styles.SkeletonText} />
                    <div className={styles.SkeletonText} />
                </BaseRecipeTeaser.Info>
                <BaseRecipeTeaser.Actions>
                    <div className={styles.SkeletonButton} />
                </BaseRecipeTeaser.Actions>
            </BaseRecipeTeaser.Content>
        </BaseRecipeTeaser.Wrapper>
    );
};

export default BaseRecipeTeaserSkeleton;
